var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path2, _path3, _polygon, _rect16, _rect17, _rect18, _rect19, _rect20, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHealthcareFacility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.75977,70V26c0-.01709-.00855-.03149-.00977-.04834V10A.7502.7502,0,0,0,60,9.25H20.02832a.7502.7502,0,0,0-.75.75V25.9082A.71874.71874,0,0,0,19.25977,26V70a.75019.75019,0,0,0,.75.75h40A.7502.7502,0,0,0,60.75977,70ZM20.77832,10.75H59.25v14.5H20.77832Zm10.48535,58.5H20.75977v-6.5h10.5039Zm16,0h-14.5v-6.5h14.5Zm11.9961,0H48.76367v-6.5h10.4961Zm0-8h-38.5V26.75h38.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75,70V66.63281a2.75,2.75,0,1,0-1.5,0V70Zm-2-6A1.25,1.25,0,1,1,66,65.25,1.25116,1.25116,0,0,1,64.75,64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75,70V66.63281a2.75,2.75,0,1,0-1.5,0V70Zm-2-6A1.25,1.25,0,1,1,14,65.25,1.25116,1.25116,0,0,1,12.75,64Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.25 22 40.75 22 40.75 18.75 44 18.75 44 17.25 40.75 17.25 40.75 14 39.25 14 39.25 17.25 36 17.25 36 18.75 39.25 18.75 39.25 22"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 66,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 66,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealthcareFacility);
export default __webpack_public_path__ + "static/media/icon_healthcare_facility.00c47a9ce38eefdbf4a559e7a1afe19a.svg";
export { ForwardRef as ReactComponent };